import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Hook to fetch CMS content for a specific page.
 * Returns a getter function: cms('key', 'default value')
 * If CMS has a value for that key, it returns it. Otherwise, returns the default.
 */
const useCMSContent = (page) => {
  const [content, setContent] = useState({});

  useEffect(() => {
    if (!page) return;
    axios.get(`${API_URL}/api/admin/content?page=${page}`)
      .then(res => {
        const items = res.data.content || res.data || [];
        const map = {};
        items.forEach(item => { map[item.key] = item.content; });
        setContent(map);
      })
      .catch(() => {});
  }, [page]);

  return (key, defaultValue) => content[key] !== undefined ? content[key] : defaultValue;
};

export default useCMSContent;
